import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const DualAuthProtectedRoute = () => {
  const { token, technicianToken } = useSelector((state) => state.auth);

  // Allow access if either token is present
  const auth = token || technicianToken;

  // If authorized, return an outlet that will render child elements
  // If not, return element that will navigate to login page
  return auth ? <Outlet /> : <Navigate to="/login" />;
};

export default DualAuthProtectedRoute;
